import React from 'react';
import { isIntersectionObserverSupported } from '../../../utils';
import { LazyIntersectionObserverCard } from './LazyIntersectionObserverCard';
import { LazyLazilyRenderCard } from './LazyLazilyRenderCard';
export default function LazyCardWithUrlContent(props) {
  if (isIntersectionObserverSupported()) {
    return /*#__PURE__*/React.createElement(LazyIntersectionObserverCard, props);
  } else {
    return /*#__PURE__*/React.createElement(LazyLazilyRenderCard, props);
  }
}